const interfaceReducer = (state, action) => {
    switch(action.type){
        case "CHANGETRUE":
            return{
                change: true
            }
        case "CHANGEFALSE":
            return {
                change: false
            }
        case "NORESULTS":
            return {
                messageError: true
            }
        case "CHANGERESULTS":
            return {
                messageError: false
            }
        default:
            return state;
    }
}

export default interfaceReducer;